import React from "react";
import "./index.scss";

const Header = () => {
  return (
    <div className="payment-header">
      <h1 className="title">Final step, make the payment.</h1>
      <p className="description">
        In order for us to provide you the best experience, the information you
        provide us is true and correct.
      </p>
    </div>
  );
};

export default Header;
